import { applyEntitySchema, objectSchema, optionalTolerant, sourceJson } from '../../_utils/fcdc-v2'
import * as z from 'zod'

const lastHardwareContactSchema = objectSchema({
  at: optionalTolerant(z.union([z.string(), z.number()])),
  lastEstablishedAt: optionalTolerant(z.union([z.string(), z.number()])),
  firmwareVersion: optionalTolerant(z.string()),
})

export class LastHardwareContact {
  at: Date
  lastEstablishedAt?: Date
  firmwareVersion: string

  constructor(json: any) {
    const source = sourceJson(json) as any
    if (source.at instanceof Date) {
      const year = source.at.getFullYear()
      const currentYear = new Date().getFullYear()
      this.at = year > currentYear + 1 ? new Date() : source.at
    } else {
      this.at = new Date(source.at)
    }

    this.firmwareVersion = source.firmwareVersion
    this.lastEstablishedAt = source.lastEstablishedAt
      ? new Date(source.lastEstablishedAt)
      : undefined
    applyEntitySchema(this, lastHardwareContactSchema, source, {})
  }
}
